import { Box, RadioGroup } from "@outschool/backpack";
import { Search } from "@outschool/business-rules";
import { useActivityString } from "@outschool/ui-components-website";
import React from "react";

import { Filter } from "../Filter";
import { ListingChildFilterProps } from "./ListingFilters";

export default function ClassSizeFilter({
  searchFilters,
  onChange,
}: ListingChildFilterProps) {
  const { classSizeOptions } = useActivityString();
  const classSize = Search.getClassSizeFromCapacityFilter(searchFilters);

  const handleFilterChange = (_e: any, selectedValue: Search.ClassSize) => {
    const filterValue = Search.getCapacityFilterFromClassSize(selectedValue);
    onChange?.(filterValue);
  };

  return (
    <Filter showTopBorder={false}>
      <Box
        sx={{
          padding: "12px 24px 24px 0px",
        }}
      >
        <RadioGroup
          name="classSize"
          value={classSize}
          options={classSizeOptions}
          onChange={handleFilterChange}
        />
      </Box>
    </Filter>
  );
}
